<template>
  <div class="c-p" @click="toTech">{{ params.data.tech_name }}</div>
</template>

<script>
export default {
  methods: {
    toTech: function () {
      let routeUrl = this.$router.resolve({
        path: "/home/consultant/consultant_dashboard",
        query: { id: this.params.data.tech_id },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>
